import { useCallback } from 'react';

import { useSetupIntent } from '../useSetupIntent';
import { useCustomerSessionQuery } from './graphql/CustomerSession.generated';

export const useCustomerSession = () => {
  const [response, refetchCustomerSession] = useCustomerSessionQuery({
    requestPolicy: 'network-only',
  });

  const customerId = response.data?.customerPaymentInfo?.id;
  const customerSessionClientSecret = response.data?.customerPaymentInfo?.paymentSessionId; // prettier-ignore

  const { setupIntentSecret, isFetchingSetupIntent, refetchSetupIntent } = useSetupIntent(!customerId); // prettier-ignore

  const refetch = useCallback(() => {
    refetchCustomerSession({ requestPolicy: 'network-only' });
    if (customerId) void refetchSetupIntent({});
  }, [customerId, refetchCustomerSession, refetchSetupIntent]);

  const isFetchingCustomerSession = response.fetching || isFetchingSetupIntent;
  const isMissingCustomerSession = !customerSessionClientSecret || !setupIntentSecret; // prettier-ignore

  return {
    customerId,
    setupIntentSecret,
    customerSessionClientSecret,
    isFetchingCustomerSession,
    isMissingCustomerSession,
    refetch,
  };
};
